import { screenshots } from "../assets/screenshots";
import { DeviceMockup } from "../components/DeviceMockup";
import type { LandingContent } from "../content/types";

type GallerySectionProps = {
  content: LandingContent["gallery"];
};

export function GallerySection({ content }: GallerySectionProps) {
  return (
    <section className="section-pad">
      <div className="site-container split-grid split-reverse">
        <div className="device-stage">
          <DeviceMockup src={screenshots.gallery} alt="Prismark gallery review interface" />
        </div>
        <div className="section-copy">
          <h2>{content.title}</h2>
          <p>{content.body}</p>
        </div>
      </div>
    </section>
  );
}
